import { Bot, Clock, PlayCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { categoryLabel, type VideoTutorial } from './video-catalog';

type ComingSoonVideoDialogProps = {
  video: VideoTutorial | null;
  onClose: () => void;
  onAskPosy: (title: string) => void;
};

/** Fiche d'un tutoriel pas encore tourné (reprise de l'ancienne modale de /tutoriels). */
export function ComingSoonVideoDialog({ video, onClose, onAskPosy }: ComingSoonVideoDialogProps) {
  if (!video) return null;
  return (
    <div
      className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-background/80 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="w-full max-w-3xl overflow-hidden rounded-xl border border-border bg-card shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative flex h-48 items-center justify-center bg-gradient-to-br from-muted to-muted/50">
          <div className="space-y-3 text-center">
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/20">
              <PlayCircle className="h-10 w-10 text-primary" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Vidéo à venir</p>
              <p className="text-xs text-muted-foreground">Ce tutoriel sera bientôt disponible</p>
            </div>
          </div>
          <Badge className="absolute right-3 top-3 bg-background/80 text-foreground backdrop-blur-sm">
            <Clock className="mr-0.5 h-3 w-3" /> {video.duration}
          </Badge>
        </div>
        <div className="space-y-2 p-5">
          <Badge variant="secondary" className="text-[10px]">
            {categoryLabel(video.category)}
          </Badge>
          <h2 className="text-lg font-semibold text-foreground">{video.title}</h2>
          <p className="text-sm text-muted-foreground">{video.description}</p>
          <div className="flex gap-2 pt-3">
            <Button variant="outline" size="sm" onClick={onClose}>
              Fermer
            </Button>
            <Button
              variant="default"
              size="sm"
              className="gap-1"
              onClick={() => onAskPosy(video.title)}
            >
              <Bot className="h-4 w-4" /> Demander à Posy
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
